// extracted by mini-css-extract-plugin
module.exports = {"banner":"principalBanner-module--banner--2Pdmi","bannerContainer":"principalBanner-module--bannerContainer--30hiA","particles":"principalBanner-module--particles--W91Ya"};